<template>
  <div class="content-wrapper pt-3 height100">
    <div class="container-fluid ">
      <div class="card mb-2 height100">
        <div class="card-body" v-loading="loading">
          <div class="flex7 mb-3">
            <div class="lh30">
              <el-button @click="$go_back" size="small" class="mr-2">返回</el-button>
            </div>
            <div class="lh30">选择建筑:
              <el-cascader size="small" :options="building_options" @change="get_building" ref="energy"
                           :props="{'value':'id','label':'name'}"></el-cascader>
            </div>
            <div>
              <el-button class="ml-3" type="primary"
                         v-if="building_id!==''&&$check_auth('CONFIG_NEW_ENERGY')"
                         @click="energy_title='新增能耗模型';get_new_energy_attr()" size="small">
                新建能耗模型
              </el-button>
              {{ building_id !== '' ? '选择查看能耗模型:' : null }}
              <el-select v-model="energy_name" placeholder="请选择" @change="get_item_tree" v-if="building_id!==''"
                         value-key="id">
                <el-option size="small"
                           v-for="item in energy_options"
                           :key="item.id"
                           :label="item.name"
                           :value="item">
                </el-option>
              </el-select>
              {{ building_id !== '' ? '分类类型:' : null }}
              <el-select v-model="item_type_name" placeholder="请选择" @change="get_item_type" v-if="building_id!==''">
                <el-option size="small"
                           v-for="item in item_type_options"
                           :key="item"
                           :label="item"
                           :value="item">
                </el-option>
              </el-select>
              <el-button type="primary" v-if="energy_name!==''&&$check_auth('CONFGI_EDIT_ENERGY')"
                         @click="energy_title='编辑能耗模型';query_modelDetail()" size="small"
                         class="ml-3">编辑能耗模型
              </el-button>
              <el-button type="danger" v-if="energy_name!==''&&$check_auth('CONFIG_DELETE_ENERGY')"
                         size="small"
                         @click="$confirm_delete('此操作将永久删除该能耗模型及其下所有分项、空间组合、设备设施组合及关联设备关系,是否继续?','delete_energy')">
                删除能耗模型
              </el-button>
              <el-button type="primary" v-if="energy_name!==''&&$check_auth('CONFIG_NEW_ITEM')"
                         @click="item_title='新增分类';get_new_item_attr()" size="small">新增分类
              </el-button>
              <el-button type="primary" v-if="energy_name!==''&&$check_auth('CONFIG_EDIT_ITEM')"
                         :disabled="current_item_name===''"
                         @click="item_title='编辑分类';edit_item()" size="small">编辑分类
              </el-button>
              <el-button type="danger" v-if="energy_name!==''&&$check_auth('CONFIG_DELETE_ITEM')"
                         :disabled="current_item_name===''"
                         @click="$confirm_delete('此操作将永久删除该分类,是否继续?','del_item')"
                         size="small">删除分类
              </el-button>
            </div>
          </div>
          <div style="margin:0 auto;width:66%;">
            <div class="row">
              <div class="col-lg-6">
                <div class="card-header bg-info2 text-white">能耗模型结构树</div>
                <div class="card">
                  <el-form class="form" @submit.native.prevent>
                    <div style="height: 550px;width:625px;overflow-y: scroll">
                      <adjustable_tree @back_call="choice_item"
                                       @del_call="$confirm_delete('此操作将永久删除该分项及所有设备关联关系,并将下级分项绑定至上级, 是否继续?','delete_item',$event)"
                                       @drop_call="drop_item" v-if="item_tree_flag"
                                       :Data="{'obj':'item_tree','data':item_tree,
                                         'attr':{'id':'id','children':'children','label':'name',
                                         'edit_func':'back_call','delete_func':'del_call',
                                         'drop_func':'drop_call','drag':true,'delete':false,
                                         'edit':true}}"></adjustable_tree>
                    </div>
                  </el-form>
                </div>
                <el-button type="primary" v-show="save_item_tree_flag" @click="save_item_tree">保存树结构
                </el-button>
              </div>
              <div class="col-lg-6">
                <div class="card-header bg-info2 text-white">
                  当前编辑分类 <span style="color: #FFC107;"
                               v-if="current_item_name!==''&&edit_item_name_flag!==true">{{
                    current_item_name
                  }}
                </span>

                </div>
                <div class="card">
                  <div class="pl-3 lh40 font16 text-info2 "
                       style="border-bottom: 1px rgb(235 231 231) solid;color: #FF9800;">按分类查找设备:
                  </div>
                  <div v-if="current_item_id!==''" class="mt-3">
                    <div class="flex3 s-list" v-if="curr_shaft===-1">
                      <span>所属楼层：</span>
                      <p v-if="floorList.length===0">暂无数据</p>

                      <div v-if="floorList.length!==0">
                                <span class="lh20 h20"
                                      :class="curr_floor===-1?'badge badge-info2' :''"
                                      @click="allFloor">全部</span>
                        <span v-for="(val,index) in floorList" class="lh20 "
                              :class="curr_floor===index?'badge badge-info2' :''"
                              :key="index"
                              @click="choiceFloor(val.id);curr_floor=index">
                                  {{ val.name }}</span>
                      </div>
                    </div>
                    <div class="flex3 s-list" v-if="curr_floor===-1">
                      <span>所属竖井：</span>
                      <p v-if="shaftList.length===0">暂无数据</p>
                      <div v-if="shaftList.length!==0">
                                <span class="lh20 h20"
                                      :class="curr_shaft===-1?'badge badge-info2' :''"
                                      @click="allShaft">全部</span>
                        <span v-for="(val,index) in shaftList" class="lh20 "
                              :class="curr_shaft===index?'badge badge-info2' :''"
                              :key="index"
                              @click="choiceShaft(val.id);curr_shaft=index">
                                  {{ val.name }}</span>
                      </div>
                    </div>
                    <div class="flex3 s-list" v-if="systemList!==undefined">
                      <span>所属空间：</span>
                      <p v-if="spaceList.length===0">请先选择建筑楼层或竖井</p>
                      <div v-if="spaceList.length!==0">
                                <span class="lh20 h20"
                                      :class="curr_space===-1?'badge badge-info2' :''"
                                      @click="allSpace">全部</span>
                        <span v-for="(val,index) in spaceList" class="lh20 "
                              :class="curr_space===index?'badge badge-info2' :''"
                              :key="index"
                              @click="choiceSpace(val.id);curr_space=index">
                                  {{ val.name }}</span>
                      </div>
                    </div>
                    <div class="flex3 s-list" v-if="equipList!==undefined">
                      <span>设备类型：</span>
                      <p v-if="equipList.length===0">暂无数据</p>
                      <div v-if="equipList.length!==0">
                        <span class="lh20 h20"
                              :class="curr_equipType===-1?'badge badge-info2' :''"
                              @click="allEquipType">全部</span>
                        <span v-for="(val,index) in equipList" :key="index"
                              class="lh20 h20"
                              @click="choiceEquipType(val.code);curr_equipType=index"
                              :class="curr_equipType===index?'badge badge-info2' :''">
                                                                    {{ val.name }}</span>
                      </div>
                    </div>
                    <div class="mt-3 text-center">
                      <el-button type="primary" @click="clear_all" size="small">重置</el-button>
                      <el-button type="success" @click="queryItemList" size="small">查询
                      </el-button>
                    </div>
                  </div>
                  <div style="border-top: 1px rgb(235 231 231) solid;" class="mt-3">
                    <div class=" p-2">
                      <object_select v-if="item_equipment_flag"
                                     @back_call="get_item_equipment_back"
                                     :Data="{'obj':'item_equipment','data':allEquipList,'attr':{'type':0,'c_priority':'M',
                                     'title':'分类关联设备','list':check_equipment_list,'func':'back_call',
                                     'show_clear':false,'show_all':false,'disabled':current_item_name===''}}">
                      </object_select>
                    </div>
                    <div class="pl-2 mb-3">
                      <el-pagination
                          @size-change="handleSizeChange"
                          @current-change="handleCurrentChange"
                          :current-page="currentPage"
                          :page-sizes="[50, 100, 200]"
                          :page-size="currentSize"
                          layout="total, sizes, prev, pager, next, jumper"
                          :total="total">
                      </el-pagination>
                    </div>
                  </div>
                  <el-button class="pl-2 mb-3" type="primary"
                             v-if="$check_auth('CONFIG_EDIT_ITEMQUE')"
                             v-show="save_item_equipment_flag" @click="save_item_equipment">
                    保存分类关联设备
                  </el-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--        新建能耗模型弹窗-->
    <el-dialog :title="energy_title" :visible.sync="dialogVisible" v-if="dialogVisible" :show-close="false"
               :close-on-press-escape="false" width="30%" :destroy-on-close="true" :close-on-click-modal="false">
      <div class=" row mb-2">
        <label class="col-sm-4  text-lr lh40"><i
            class="fa fa-asterisk text-danger font10 ml-1"
            aria-hidden="true"></i>能耗名称：</label>
        <div class="col-sm-7 flex1 lh35">
          <el-input style="margin-bottom: 0px" size=""
                    v-model=" $store.state.new_energy_attr_list.name"
                    placeholder="请输入内容">
          </el-input>
        </div>
      </div>
      <div v-if="new_energy_attr_list.object_data!==undefined">
        <div v-for="(item,index) in new_energy_attr_list.object_data.static_attribute" :key="index">
          <equip_attr_temp v-if="item.c_priority!=='A'&&item.c_data_type!=='Json'"
                           :Data="{'data':item,'attr':{'type':'enery','objType':'new_energy'}}"
          ></equip_attr_temp>
          <div v-if="item.c_data_type==='Json'">
            <season_block :Data="{'obj':'new_energy','data':item,'attr':''}" v-if="item.c_code==='500007'"></season_block>
            <workDay_block :Data="{'obj':'new_energy','data':item,'attr':''}" v-if="item.c_code==='500008'"></workDay_block>
            <workTime_block :Data="{'obj':'new_energy','data':item,'attr':''}" v-if="item.c_code==='500009'"></workTime_block>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
                <el-button @click="new_energy_attr_list.object_data=[];dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="to_add_energy">保 存</el-button>
            </span>
    </el-dialog>
    <!--        新建分类弹窗-->
    <el-dialog :title="item_title" :visible.sync="itemVisible" v-if="itemVisible" :show-close="false"
               :close-on-press-escape="false" width="30%" :close-on-click-modal="false">
      <div v-if="item_flag">
        <div class=" row mb-2">
          <label class="col-sm-4  text-lr lh40"><i
              class="fa fa-asterisk text-danger font10 ml-1"
              aria-hidden="true"></i>分类名称：</label>
          <div class="col-sm-7 flex1 lh35">
            <el-input style="margin-bottom: 0px" size=""
                      v-model=" itemTypeName "
                      placeholder="请输入内容"></el-input>
          </div>
        </div>
        <div class=" row mb-2">
          <label class="col-sm-4  text-lr lh40"><i
              class="fa fa-asterisk text-danger font10 ml-1"
              aria-hidden="true"></i>分类类型：</label>
          <div class="col-sm-7 flex1 lh35">
            <el-input style="margin-bottom: 0px" size=""
                      v-model=" itemTypeType "
                      placeholder="请输入内容"></el-input>
          </div>
        </div>

        <div v-if="new_item_attr_list.object_data!==undefined">
          <div v-for="(item,index) in new_item_attr_list.object_data.static_attribute" :key="index">
            <equip_attr_temp v-if="item.c_priority!=='A'"
                             :Data="{'data':item,'attr':{'type':'enery','objType':'new_item'}}"
            ></equip_attr_temp>


          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
                <el-button @click="itemVisible = false">取 消</el-button>
                <el-button type="primary" @click="to_save_item">保 存</el-button>
            </span>
    </el-dialog>
    <el-dialog title="修改能耗模型名称" :visible.sync="edit_energy_name_flag" v-if="edit_energy_name_flag"
               :show-close="false"
               :close-on-press-escape="false" width="30%" :close-on-click-modal="false">
      <el-input v-model="input" placeholder="请输入内容"></el-input>
      <span slot="footer" class="dialog-footer">
                <el-button @click="edit_energy_name_flag = false">取 消</el-button>
                <el-button type="primary" @click="edit_energy_name">保 存</el-button>
            </span>
    </el-dialog>
  </div>
</template>

<script>
import adjustable_tree from "@/components/IBMS/function/special_func_group/adjustable_tree"
import object_select from "@/components/IBMS/function/special_func_group/object_select"
import equip_attr_temp from "@/components/IBMS/function/special_func_group/equip_attr_temp";
import season_block from "@/components/IBMS/function/special_func_group/season_block";
import workDay_block from "@/components/IBMS/function/special_func_group/workDay_block";
import workTime_block from "@/components/IBMS/function/special_func_group/workTime_block";

export default {
  name: "edit_energy",
  components: {
    adjustable_tree, object_select, equip_attr_temp,season_block,workDay_block,workTime_block
  },
  data() {
    return {
      input: '',
      edit_energy_name_flag: false,
      equipment_type_flag: true,
      edit_item_name: '',
      edit_item_name_flag: false,
      building_id: '',
      building_options: [],
      space_id: '',
      func: '',
      equipment_type: '',
      check_equipment_list: [],
      equipment_list: [],
      item_equipment_flag: true,
      total: 0,
      currentSize: 50,
      currentPage: 1,
      save_item_tree_list: [],
      save_item_tree_flag: true,
      current_item_id: '',
      current_item_name: '',
      save_item_equipment_flag: false,
      item_tree_flag: true,
      item_tree: [],
      item_type: '',
      relation_code: '',
      item_code: '',
      item_flag: true,
      itemVisible: false,
      new_item_attr_list: [],
      new_energy_attr_list: [],
      dialogVisible: false,
      loading: false,
      // func_options: [],
      type_options: [],
      location_options: [],
      energy_options: [],
      energy_id: '',
      energy: '',
      platformid: this.$store.state.platform_Id,
      energy_name: '',


      project_id: this.$store.state.project_id,
      curr_major: -1,
      curr_system: -1,
      curr_equipType: -1,
      curr_build: -1,
      curr_floor: -1,
      curr_shaft: -1,
      curr_space: -1,
      floorList: [],
      shaftList: [],
      spaceList: [],
      systemList: [],
      equipList: [],
      itemTreeData: [],
      code: '',
      allEquipList: [],
      energyName: '',
      item_type_name: '',
      item_type_options: [],
      itemTypeName: '',
      itemTypeType: '分项',
      floorId: '',
      shaftId: '',
      spaceId: '',
      equip_code: '22',
      item_title: '',
      energy_title: '',



    }
  },
  mounted() {
    this.get_building_list()
  },
  methods: {


    //查询能耗模型类型
    query_modelDetail() {
      this.$axios({
        method: 'post',
        url: this.IBMS_API + 'IBMS/Public/QueryObjectDetailTree',
        data: {
          "version": "1.1",
          "data": {
            "id": this.root_id,
          }
        }
      }).then((response) => {
        console.log(response)
        this.new_energy_attr_list = response.data.content
        this.$store.commit('set_new_energy_attr_list', this.new_energy_attr_list.object_data)
        this.dialogVisible = true

      })
    },
    //选择类型
    get_item_type(data) {
      console.log(data)
      this.query_item_tree()

    },

    //选的能耗类型：是否使用默认分项模型的显示
    getEnergy(data) {
      console.log(data, 'data')
      this.energy = data
    },
    //删除分类
    del_item() {
      this.$axios({
        method: 'post',
        url: this.IBMS_API + 'IBMS/Public/DeprecatOrDeleteObject',
        data: {
          "version": "1.1",
          "data": {
            "id_list": [this.current_item_id],
            "flag": 'delete',
          }
        }
      }).then((response) => {
        if (response.data.result === 200) {
          this.$message({
            showClose: true,
            type: 'success',
            message: '删除成功!'
          });
          this.get_item_tree()
        } else {
          this.$message({
            showClose: true,
            message: '删除失败请稍后重试',
            type: 'error'
          });
        }
      })
    },
    //编辑分类
    edit_item() {
      this.$axios({
        method: 'post',
        url: this.IBMS_API + 'IBMS/Public/QueryObjectDetailTree',
        data: {
          "version": "1.1",
          "data": {
            "id": this.current_item_id,
          }
        },
      }).then((response) => {
        console.log(response)
        this.new_item_attr_list = response.data.content
        this.itemTypeName = response.data.content.object_data.name
        this.itemTypeType = response.data.content.object_data.item_type
        this.$store.commit('set_new_item_attr_list', this.new_item_attr_list.object_data)
        this.itemVisible = true


      })


    },
    //修改能耗模型名称
    edit_energy_name() {//接口文档中无该接口
      this.$axios({
        method: 'post',
        url: this.IBMS_API + 'IBMS/global/CONFIG/EditEnergy/EditItemName',
        data: {
          "version": "1.1",
          "data": {
            "item_id": this.energy_id,
            "item_name": this.input,
            "platform_id": this.platformid,
          }
        },
      }).then((response) => {
        if (response.data.result === 200) {
          this.$message({
            showClose: true,
            message: '修改成功',
            type: 'success'
          });
        }
      })
      this.edit_energy_name_flag = false
    },
    //删除能耗模型
    delete_energy() {
      this.$axios({
        method: 'post',
        url: this.IBMS_API + 'IBMS/Public/DeprecatOrDeleteObject',
        data: {
          "version": "1.1",
          "data": {
            "id_list": [this.root_id],
            "flag": 'delete',
          }
        }
      }).then((response) => {
        if (response.data.result === 200) {
          this.$message({
            showClose: true,
            type: 'success',
            message: '删除成功!'
          });
          this.current_item_id = ''
          this.current_item_name = ''
          this.item_type = ''
          this.item_code = ''
          this.func = ''
          this.energy_name=''
          this.clear_all()
          this.get_energy_list()
        } else {
          this.$message({
            showClose: true,
            message: '删除失败请稍后重试',
            type: 'error'
          });
        }
      })
    },
    //查询空间树结构
    query_space_tree() {
      this.$axios({
        method: 'post',
        url: this.IBMS_API + 'IBMS/generic/QuerySpaceTree',
        data: {
          "version": "1.1",
          "data": {
            "projectId": this.project_id,
            "platform_id": this.platformid,
          }
        },
      }).then((response) => {
        this.location_options = response.data.content.spaceList
      })
    },
    //获取空间id
    get_location(e) {
      this.space_id = e
    },
    //修改分类名
    save_edit_item_name() {//接口文档中无该接口
      this.$axios({
        method: 'post',
        url: this.IBMS_API + 'IBMS/global/CONFIG/EditEnergy/EditItemName',
        data: {
          "version": "1.1",
          "data": {
            "item_id": this.current_item_id,
            "item_name": this.edit_item_name,
            "platform_id": this.platformid,
          }
        },
      }).then((response) => {
        if (response.data.result === 200) {
          this.$message({
            showClose: true,
            message: '修改成功',
            type: 'success'
          });
          this.edit_item_name = ''
          this.edit_item_name_flag = false
          this.get_item_tree()
        }
      })
    },
    //选中建筑
    get_building(e) {
      this.building_id = e[0]
      this.current_item_id = ''
      this.current_item_name = ''
      this.energy_name = ''
      // this.clear_all()
      this.get_energy_list()
    },
    //查询建筑列表
    get_building_list() {
      this.$axios({
        method: 'get',
        url: this.IBMS_API + 'IBMS/Public/QueryObjectList',
        params: {
          "object_code": '12',
          "project": this.project_id,
        },
      }).then((response) => {
        this.building_options = response.data.content.data
      })
    },
    //重置
    clear_all() {
      this.equipment_type = ''
      // this.func = ''
      this.space_id = ''
      this.floorId = ''
      this.shaftId = ''
      this.equip_code = '22'
      this.curr_floor = -1
      this.curr_shaft = -1
      this.curr_space = -1
      this.curr_major = -1
      this.curr_system = -1
      this.curr_equipType = -1
      this.systemList = []
      this.equipList = []
      this.save_item_equipment_flag = false
      this.equipment_type_flag = false
      this.$nextTick((() => {
        this.equipment_type_flag = true
      }))
      this.queryItemList()
    },
    //选中设备类
    get_equipment_type(e) {
      this.equipment_type = e
    },
    //查询设备类
    query_equipment_type() {
      this.$axios({
        method: 'post',
        url: this.IBMS_API + 'IBMS/generic/QueryItemTree',
        data: {
          "version": "1.1",
          "data": {
            "platform_id": this.platformid,
          }
        },
      }).then((response) => {
        this.type_options = response.data.content.equipTypeList
      })
    },
    //获取选中分类关联设备项列表
    get_item_equipment_back(data) {
      console.log(data, 'e')
      this.save_item_equipment_flag = true
      // console.log(e)
    },
    //更变页码
    handleCurrentChange(e) {
      this.currentPage = e
      this.queryItemList()
      // this.query_item_list()
    },
    //更变每页条数
    handleSizeChange(e) {
      this.currentSize = e
      this.queryItemList()
      // this.query_item_list()
    },
    //选择分类
    choice_item(value) {
      this.current_item_id = value.data.id
      this.current_item_name = value.data.name
      this.check_equipment_list = value.data.equipment_list
      this.currentPage = 1
      this.query_itemTree()//查询专业树
      this.queryItemList()//查询设备列表
      this.query_floor()//查询楼层列表
      this.query_shaft()//查询竖井列表
      this.query_space()//查询空间列表
    },
    // //删除分类
    // del_item(title,func_name,value) {
    //     this.$confirm_delete(title, func_name, value)
    // },
    //拖动分类
    drop_item(value) {
      if (!this.save_item_tree_flag) this.save_item_tree_flag = true
      this.save_item_tree_list = value
    },
    //删除分类
    delete_item(value) {//无该接口
      if (this.item_type === '42') {
        this.relation_code = '57030103'
      } else if (this.item_type === '47') {
        this.relation_code = '57030108'
      } else if (this.item_type === '48') {
        this.relation_code = '57030111'
      }
      this.$axios({
        method: 'post',
        url: this.IBMS_API + 'IBMS/global/CONFIG/EditEnergy/DeleteItem',
        data: {
          "version": "1.1",
          "data": {
            "item_id": value.data.id,
            "item_type": this.item_type,
            "platform_id": this.platformid,
          }
        }
      }).then((response) => {
        if (response.data.result === 200) {
          this.$message({
            showClose: true,
            type: 'success',
            message: '删除成功!'
          });
          this.get_item_tree()
        } else {
          this.$message({
            showClose: true,
            message: '删除失败请稍后重试',
            type: 'error'
          });
        }
      })
    },
    //查询设备列表
    query_item_list() {
      this.loading = true
      this.$axios({
        method: 'post',
        url: this.IBMS_API + 'IBMS/global/CONFIG/EditEnergy/queryEquipByCondition',
        data: {
          "version": "1.1",
          "data": {
            "project_id": this.project_id,
            "page_num": this.currentPage,
            "page_size": this.currentSize,
            "id_list": this.check_equipment_list,
            "category": this.equipment_type,
            "func": this.func,
            "space_id": this.space_id,
            "platform_id": this.platformid,
          }
        }
      }).then((response) => {
        if (response.data.result === 200) {
          this.total = response.data.content.total_count
          this.equipment_list = response.data.content.equip_list
        }
        this.loading = false
      })
    },
    //查询分类关联设备
    query_item_equipment() {
      if (this.item_type === '42') {
        this.relation_code = '57030105'
      } else if (this.item_type === '47') {
        this.relation_code = '57030106'
      } else if (this.item_type === '48') {
        this.relation_code = '57030109'
      }
      this.$axios({
        method: 'post',
        url: this.IBMS_API + 'IBMS/global/CONFIG/EditEnergy/ItemEquipment',
        data: {
          "version": "1.1",
          "data": {
            "item_id": this.current_item_id,
            "relation_code": this.relation_code,
            "platform_id": this.platformid,
          }
        }
      }).then((response) => {
        if (response.data.result === 200) {
          this.check_equipment_list = response.data.content
          this.$nextTick(() => {
            this.queryItemList()
            // this.query_item_list()
            this.item_equipment_flag = false
            this.$nextTick(() => {
              this.item_equipment_flag = true
            })
          })
        }
      })
    },
    //保存分类关联设备
    save_item_equipment() {
      this.save_item_equipment_flag = false
      this.$axios({
        method: 'post',
        url: this.IBMS_API + 'IBMS/Public/EditItemHaveEquipment',
        data: {
          "version": "1.1",
          "data": {
            "item_id": this.current_item_id,
            "equipment_list": this.$store.state.item_equipment_data,
          }
        }
      }).then((response) => {
        if (response.data.result === 200) {
          this.$message({
            showClose: true,
            type: 'success',
            message: '保存成功!'
          });
          let temp = JSON.stringify(this.$store.state.item_equipment_data)
          this.check_equipment_list = JSON.parse(temp)
          this.$store.commit('set_item_equipment_data', [])
        } else {
          this.$message({
            showClose: true,
            message: '保存失败!' + response.data.content,
            type: 'error'
          });
        }
        this.query_item_tree()
      })
    },
    //保存树结构
    save_item_tree() {
      this.$axios({
        method: 'post',
        url: this.IBMS_API + 'IBMS/Public/EditObjectTree',
        data: {
          "version": "1.1",
          "data": {
            "object_code": '42',
            "project_id": this.project_id,
            "object_list": this.item_tree,
          }
        }
      }).then((response) => {
        if (response.data.result === 200) {
          this.$message({
            showClose: true,
            type: 'success',
            message: '保存成功!'
          });
          this.query_item_tree()
        } else {
          this.$message({
            showClose: true,
            message: '保存失败请稍后重试',
            type: 'error'
          });
        }
        this.loading = false
      })
    },
    //获取分类树结构
    get_item_tree(data) {
      this.item_type_options = data.item_type_list
      this.root_id = data.id
      this.item_type_name = ''
    },
    query_item_tree() {
      this.$axios({
        method: 'get',
        url: this.IBMS_API + 'IBMS/Public/QueryObjectTree',
        params: {
          "root_id": this.root_id,
          "item_type": this.item_type_name,
          "project_id": this.project_id,
          "object_code": '42',

        }
      }).then((response) => {
        this.item_tree = response.data.content
      })
    },
    //获取新增分类属性列表
    get_new_item_attr() {
      this.itemVisible = true
      this.$axios({
        method: 'post',
        url: this.IBMS_API + 'IBMS/Public/GetNewObjectAttribute',
        data: {
          "version": "1.1",
          "data": {
            "object_code": '42',
          }
        }
      }).then((response) => {
        this.new_item_attr_list = response.data.content
        this.$store.commit('set_new_item_attr_list', this.new_item_attr_list.object_data)
        console.log(this.new_item_attr_list)
      })
    },
    to_save_item() {
      let u = ''
      if (this.item_title === '新增分类') {
        u = 'IBMS/Public/AddNewObject'
      } else {
        u = 'IBMS/Public/UpdateObject'
      }
      this.add_item(u)
    },
    //新增分类
    add_item(u) {
      let check = this.$check_data([this.$store.state.new_item_attr_list.static_attribute])
      if (!check) return
      this.$store.state.new_item_attr_list.name = this.itemTypeName
      this.$store.state.new_item_attr_list.energy_model = this.root_id
      this.$store.state.new_item_attr_list.item_type = this.itemTypeType
      this.$store.state.new_item_attr_list.project = this.project_id
      // this.save_item_tree()
      this.$axios({
        method: 'post',
        url: this.IBMS_API + u,
        data: {
          "version": "1.1",
          "data": {
            "object_data": this.$store.state.new_item_attr_list,

          }
        }
      }).then((response) => {
        if (response.data.result === 200) {
          this.$message({
            showClose: true,
            message: '新建成功',
            type: 'success'
          });
          this.new_item_attr_list = []
          this.item_flag = false
          this.$nextTick(() => {
            this.item_flag = true
          })
          this.itemVisible = false
          this.current_item_name = ''
          this.current_item_id = ''
          this.energy_name = ''
          this.item_type_name = ''
          this.$store.commit('set_new_item_attr_list', [])
          this.query_item_tree()
          this.get_energy_list()
        }
      })
    },
    //查询能耗模型列表
    get_energy_list() {
      this.$axios({
        method: 'get',
        url: this.IBMS_API + 'IBMS/Public/QueryObjectList',
        params: {
          'building': this.building_id,
          "project": this.project_id,
          "object_code": '41',
        }
      }).then((response) => {
        this.energy_options = response.data.content.data
        this.item_tree = []
        this.equipment_list = []
        this.total = 0
        this.item_tree_flag = false
        this.save_item_equipment_flag = false
        this.item_equipment_flag = false
        this.$nextTick((() => {
          this.item_tree_flag = true
          this.item_equipment_flag = true
        }))
      })
    },
    to_add_energy(){
      let u=''
      if(this.energy_title==='新增能耗模型'){
        u='IBMS/Public/AddNewObject'
      }else {
        u='IBMS/Public/UpdateObject'
      }
      this. add_energy(u)
    },
    //新增/编辑能耗模型
    add_energy(u) {
      let x = this.$check_data([this.$store.state.new_energy_attr_list.static_attribute])
      if (!x) return
      this.$store.state.new_energy_attr_list.building = this.building_id
      this.$store.state.new_energy_attr_list.project = this.project_id
      this.$axios({
        method: 'post',
        url: this.IBMS_API + u,
        data: {
          "version": "1.1",
          "data": {
            "object_data": this.$store.state.new_energy_attr_list,
          }
        }
      }).then((response) => {
        if (response.data.result === 200) {
          this.$message({
            showClose: true,
            message: '新建成功',
            type: 'success'
          });
          this.dialogVisible = false
          this.new_energy_attr_list = []
          this.$store.commit('set_new_energy_attr_list', [])
          this.get_energy_list()
        }
      })
    },
    //查询新建能耗模型属性
    get_new_energy_attr() {
      this.dialogVisible = true
      this.$axios({
        method: 'post',
        url: this.IBMS_API + 'IBMS/Public/GetNewObjectAttribute',
        data: {
          "version": "1.1",
          "data": {
            "object_code": '41',
          }
        }
      }).then((response) => {
        this.new_energy_attr_list = response.data.content
        this.$store.commit('set_new_energy_attr_list', this.new_energy_attr_list.object_data)
      })
    },
    //全部建筑
    allBuild() {
      this.buildingId = ''
      this.curr_build = -1
      this.curr_major = -1;
      this.curr_floor = -1;
      this.curr_shaft = -1;
      this.curr_space = -1;
      this.curr_equipType = -1
      this.majorId = ''
      this.systemId = ''
      this.floorId = ''
      this.shaftId = ''
      this.spaceId = ''
      this.equipTypeId = ''
      this.systemList = []
      this.equipList = []
      this.floorList = []
      this.shaftList = []
      this.spaceList = []
      this.equip_code = '22'
      this.queryItemList()
      // this.query_space()

    },
    allFloor() {
      this.floorId = ''
      this.spaceId = ''
      this.curr_floor = -1
      this.spaceList = []
      this.queryItemList()
      this.query_space()
    },
    allShaft() {
      this.shaftId = ''
      this.spaceId = ''
      this.curr_shaft = -1
      this.spaceList = []
      this.queryItemList()
      this.query_space()
    },
    allSpace() {
      this.spaceId = ''
      this.curr_space = -1
      this.queryItemList()
    },
    allEquipType() {
      this.curr_equipType = -1
      this.equipTypeId = ''
      this.equip_code ='21805'
      // this.queryItemList();
    },

    choiceEquipType(id) {
      this.equipTypeId = id
      this.equip_code = id
    },
    //查询设备列表
    queryItemList() {
      this.item_equipment_flag = false
      this.allEquipList = []
      this.$axios({
        method: 'get',
        url: this.IBMS_API + 'IBMS/Public/QueryObjectList',
        params: {
          "project": this.project_id,
          "building": this.building_id,
          "floor": this.floorId,
          "shaft": this.shaftId,
          "space": this.spaceId,
          "deprecated": this.curr_deprecated,
          'object_code': this.equip_code,
          'page': this.currentPage,
          'size': this.currentSize,
          "query_flag": '1',
          "order_id": this.current_item_id,
        },
      }).then((response) => {
        this.total = response.data.content.totalElements
        this.allEquipList = response.data.content.data
        this.item_equipment_flag = true
      })
    },
    //查询楼层
    query_floor() {
      this.$axios({
        method: 'get',
        url: this.IBMS_API + 'IBMS/Public/QueryObjectList',
        params: {
          "project": this.project_id,
          "building": this.building_id,
          'object_code': '13',
        },
      }).then((response) => {
        this.floorList = response.data.content.data
      })
    },
    //查询竖井
    query_shaft() {
      this.$axios({
        method: 'get',
        url: this.IBMS_API + 'IBMS/Public/QueryObjectList',
        params: {
          "project": this.project_id,
          "building": this.building_id,
          'object_code': '14',
        },
      }).then((response) => {
        this.shaftList = response.data.content.data
      })
    },
    //查询空间
    query_space() {
      this.$axios({
        method: 'get',
        url: this.IBMS_API + 'IBMS/Public/QueryObjectList',
        params: {
          "project_id": this.project_id,
          "building": this.building_id,
          "floor": this.floorId,
          "shaft": this.shaftId,
          'object_code': '1501',
        },
      }).then((response) => {
        this.spaceList = response.data.content.data
      })
    },
    //查询设备类型树
    query_itemTree() {
      this.$axios({
        method: 'post',
        url: this.IBMS_API + 'IBMS/Public/QueryTypeTree',
        data: {
          "version": "1.1",
          "data": {
            'type': '设备',
            'code': '21805',
          }
        },
      }).then((response) => {
          this.equipList = response.data.content.list
      })
    },
    //选择楼层
    choiceFloor(data) {
      this.shaftId = ''
      this.floorId = data
      this.query_space()
    },
    //选择竖井
    choiceShaft(data) {
      this.floorId = ''
      this.shaftId = data
      this.query_space()
    },
    choiceSpace(data) {
      this.spaceId = data
      this.queryItemList()
    },
  }
}
</script>

<style scoped>
/deep/ .el-tree-node__content {
  display: flex;
  align-items: center;
  height: 31px;
  cursor: pointer;
}

/deep/ input::-webkit-input-placeholder {
  color: red;
}

:deep(.number) {
  color: #000;
}
</style>